import './scss/offers-list.scss';

import 'lazysizes';
import './common';
import { makeResponsive } from "./components/responsitive";

makeResponsive();
